export const SIZE_TIMELINE_PLUGIN = {
    width: 25,
    height: 25,
    customWidth: 15,
    customHeight: 15,
    backgroundRadius: 5,
    customRadiusMax: 7,
    customRadiusMin: 3,
    customLineWidth: 1.5,
    customInsideElemWidth: 2,
    backgroundColor: "#E5E5E5",
    defaultPosition: { x: 1.5, y: 1.5 }
};

export const PI_USER_ACTIONS = [
    "RETRY",
    "DOWNLOAD_LOG",
    "ARCHIVE",
    "VIEW_LOG",
    "SAVE_DATA_MODEL",
    "TERMINATE",
    "DELETE_DATA_MODEL_VALUES",
    "DELETE_DATA_MODEL_AUDIT",
    "ANONYMIZE_PERSONAL_INFO"
];
